import { render, staticRenderFns } from "./index.vue?vue&type=template&id=53bd79be&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=53bd79be&scoped=scoped&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53bd79be",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\code\\aihuz\\arbitration-ui\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('53bd79be')) {
      api.createRecord('53bd79be', component.options)
    } else {
      api.reload('53bd79be', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=53bd79be&scoped=true&", function () {
      api.rerender('53bd79be', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/configure/arbitratorFree/index.vue"
export default component.exports